import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import api, { apiError } from "@/lib/api";

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email });
      toast.success(data.message || "Subscribed!");
      setDone(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="border border-emerald-500/30 rounded-md bg-emerald-600/10 p-5 text-center" data-testid="newsletter-done">
        <p className="font-head font-semibold text-emerald-300">You're in — see you in your inbox.</p>
        <p className="text-sm text-zinc-400 mt-1">One practical guide a week. Unsubscribe anytime.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-blue-500/30 rounded-md bg-blue-600/10 p-5" data-testid="newsletter-form">
      <p className="font-head font-semibold mb-1 flex items-center gap-2">
        <Mail className="h-4 w-4 text-blue-400" /> Get the weekly guide in your inbox
      </p>
      <p className="text-sm text-zinc-400 mb-3">One practical faceless-video guide per week. No spam, unsubscribe anytime.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid="newsletter-email-input"
          className="flex-1 bg-[#0A0A0A] border border-white/10 rounded-md px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="newsletter-subscribe-btn"
          className="bg-blue-600 hover:bg-blue-500 px-5 py-2 rounded-md text-sm font-semibold text-white transition-colors disabled:opacity-60"
        >
          {busy ? "Subscribing…" : "Subscribe"}
        </button>
      </div>
    </form>
  );
};
